export default "__VITE_ASSET__Cnj5VIvE__"